// TODO: idk if it's the best idea

export const aboutUsStyle = {
    container: {
      position: "relative" as const,
      height: "60vh",
      backgroundImage: "url('/path-to-your-background-image.jpg')", // Replace with the correct path
      backgroundSize: "cover" as const,
      backgroundPosition: "center" as const,
    },
    overlay: {
      position: "absolute" as const,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 47, 167, 0.8)", // Blue overlay with transparency
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column" as const,
    },
    header: {
      textAlign: "center" as const,
      color: "#ffffff",
    },
    title: {
      fontSize: "48px",
      fontWeight: "bold" as const,
      marginBottom: "20px",
      marginTop: "60px"
    },
    subtitle: {
      fontSize: "24px",
      marginBottom: "40px",
      maxWidth: "600px",
    },
    button: {
      padding: "15px 30px",
      fontSize: "18px",
      color: "#004fa7",
      backgroundColor: "#ffffff",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
    spacer: {
      height: "40px", // Spacer to create space between sections
    },
    valuesContainer: {
      padding: "0 20px", // Add some horizontal padding if needed
    },
  };